/*
 * @Author: cc
 * @Date: 2019-12-08 19:24:26
 * @LastEditTime: 2021-07-16 17:40:12
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\newspaper\preview\previewCtrl.js
 * @Description: 报纸渠道查看页
 */

'use strict';
angular
    .module('newspaperPreviewModule', ['newspaperDraftCorrelationModule'])

    /*
     *controller:
     *newspaperPreviewCtrl:报纸细缆控制器
     */
    .controller('newspaperPreviewCtrl', [
        '$scope',
        '$timeout',
        '$q',
        '$stateParams',
        '$state',
        '$window',
        'trsHttpService',
        'editcenterRightsService',
        'editingCenterService',
        'draftCorrela',
        'storageListenerService',
        'localStorageService',
        'trsPrintService',
        'editIsLock',
        'modalDialog',
        'editNewspaperService',
        'editingMediatype',
        '$compile',
        '$element',
        function (
            $scope,
            $timeout,
            $q,
            $stateParams,
            $state,
            $window,
            trsHttpService,
            editcenterRightsService,
            editingCenterService,
            draftCorrela,
            storageListenerService,
            localStorageService,
            trsPrintService,
            editIsLock,
            modalDialog,
            editNewspaperService,
            editingMediatype,
            $compile,
            $element
        ) {
            initstatus();
            initData();

            /**
             * [initstatus description]
             * @return  {[type]}  [return description]
             */
            function initstatus() {
                $scope.status = {
                    picsModelShow: true,
                    isShowPicDirective: false, // 是否展示图集详情指令
                    // 初始化按钮
                    btnRights: {},
                    onlyPreview: $state.params.paperid === '0',
                    // 是否选中
                    ischoose: {
                        mark: false,
                        key: '',
                    },
                    copyLinkActive: false,
                    fusionNewpaper: !!$stateParams.iwometadataid,
                    // 选择预览新闻或者图集
                    preview: {
                        news: '1',
                        atlas: '2',
                    },
                    isRequestData: '0',
                    previewBigFace: {
                        status: false,
                    },
                    // 进入预览页的报纸
                    methodname: ['paper.dyg', 'paper.jrg', 'paper.sbg', 'paper.yqg', 'paper.gdg'],
                    listOpen: 1,
                    num: 0, // 稿件类型颜色
                    outfusionWay: !$stateParams.iwometadataid, // 融合详情页不显示
                    // 关联稿件类型
                    relatedDarftObj: {
                        29: {
                            type: '4',
                            name: '归档稿',
                            num: '5',
                        },
                        30: {
                            type: '1',
                            name: '今日稿',
                            num: '3',
                        },
                        31: {
                            type: '0',
                            name: '待用稿',
                            num: '1',
                        },
                        32: {
                            type: '1',
                            name: '今日稿',
                            num: '3',
                        },
                        33: {
                            type: '1',
                            name: '今日稿',
                            num: '3',
                        },
                        34: {
                            type: '2',
                            name: '上版稿',
                            num: '4',
                        },
                        35: {
                            type: '3',
                            name: '已签稿',
                            num: '2',
                        },
                        36: {
                            type: '3',
                            name: '已签稿',
                            num: '2',
                        },
                        37: {
                            type: '3',
                            name: '已签稿',
                            num: '2',
                        },
                        38: {
                            type: '3',
                            name: '已签稿',
                            num: '2',
                        },
                    },
                    // previewtype: $stateParams.newspapertype,
                    // 预览相关联方法
                    queryMethodName: [
                        'queryRelateDocsInDaiYong',
                        'queryRelateDocsInJinRi',
                        'queryRelateDocsInShangBan',
                        'queryReleteDocsInYiQianFa',
                        'queryReleteDocsInGuiDang',
                    ],
                    bitFaceTit: '查看痕迹',
                    // 初始化跳转显示
                    switchShow: true,
                    // 初始化关联稿
                    RelatedDarft: [],
                    // 初始化选中集合
                    selectArray: [],
                    // 初始化选中对象
                    // clickedItem: "",
                    // 默认选中对象
                    // selectDefault: item,
                    // 默认选择集合
                    // selectCurrent: items.DOCUMENTS,
                    // 默认选择集合METADATAID
                    current: [],
                    previewCache: 'newspaperPreviewCache',
                    previewMetadataid: [],
                    previewItemMetadata: '',
                    // 从缓存拿出
                    selectArrayIdCache: [],
                    authorInfo: true, // 作者信息选中
                    isCollectDraft: $stateParams.iwomodalname === 'iwo.collect',
                    isawaitrevise: $state.params.isawaitrevise || $state.params.paperstatusname === '待修订', // 是否是待修订
                };
                getUeditorCss();
            }

            /**
             * [initData description] 初始化数据
             * @return  {[type]}  [return description]
             */
            function initData() {
                $scope.data = {
                    item: [],
                    fusionRouter: {
                        // 融合编辑器路由
                        '1': 'fusionnews',
                        '2': 'fusionatlas',
                        '4': 'fusionlinkdoc',
                        '5': 'fusionactivity',
                        '6': 'fusiontopic',
                        '7': 'fusionvideo',
                        '8': 'fusionlive',
                    },
                    // 当前报纸信息
                    paperMsg: '',
                    params: {
                        serviceid: 'mlf_paper',
                        methodname: 'queryViewDatas',
                        MetaDataIds: $stateParams.bzmetadata,
                        fromsearch: $stateParams.fromsearch
                    },
                    newspaperEdit: {
                        1: 'newspapertext',
                        2: 'newspaperpic',
                    },
                    preview: {
                        news: '1',
                        atlas: '2',
                    },
                    METADATAID: $stateParams.bzmetadata,
                    paperstatusname: $stateParams.paperstatusname,
                };
                // $scope.status = {

                // };
                if (!!$stateParams.iwometadataid) {
                    $scope.data.params = {
                        serviceid: 'mlf_fusioncreate',
                        methodname: 'getPaperFusionDoc',
                        sourceDocId: $stateParams.iwometadataid,
                    };
                }
                // 当前报纸信息
                if (!$stateParams.iwometadataid && !$scope.status.onlyPreview) {
                    // news
                    editingCenterService.getSiteInfo($stateParams.paperid).then(function (data) {
                        $scope.data.paperMsg = data;
                    });
                }
                storageListenerService.removeListener('newspaper');
                requestData();
                watchSelected();
            }

            /**
             * [getDraftStage description] 获取当前稿件在哪个审核阶段（去除需要传入的wzplatform的情况，主要是从IM来的稿件）
             * @return  {[type]}  [return description]
             */
            function getDraftStage(){
                var defer = $q.defer();
                editingCenterService.getDraftStage($scope.data.item, {
                    mediatype: editingMediatype.newspaper,
                    metadataid: $state.params.bzmetadata
                }).then((data) => {
                    $state.params.newspapertype = data;
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [watchSelected description] 监控列表的选择情况
             * @return {[type]} [description]
             */
            function watchSelected() {
                window.addEventListener('storage', watcher);

                /**
                 * [watcher description]
                 *
                 * @param   {[type]}  e  [e description]
                 *
                 * @return  {[type]}     [return description]
                 */
                function watcher(e) {
                    // $scope.chooseItem
                    if (e.key == 'ls.newspaperPreviewSelectArray') {
                        $scope.status.selectArrayIdCache = localStorageService.get('newspaperPreviewSelectArray');
                        isMark($state.params.bzmetadata);
                    }
                }
                $scope.$on('$destroy', function () {
                    window.removeEventListener('storage', watcher);
                });
            }

            /**
             * [dealRights description] 处理权限
             *
             * @return  {[type]}  [return description]
             */
            function dealRights() {
                if ($scope.status.onlyPreview) {
                    return;
                }
                if (!!$stateParams.iwometadataid) {
                    if (!$stateParams.departmentDocId) {
                        editcenterRightsService.initIwoListBtn($stateParams.iwomodalname).then(function (data) {
                            $scope.status.btnRights = data;
                        });
                    } else {
                        getDepartDocAuthority();
                    }
                    // 获取查看痕迹按钮权限
                    editcenterRightsService.initIwoListBtn('iwo.trace').then(function (data) {
                        $scope.status.bigFaceRights = !!data['iwo.trace.chakan'] ? 'true' : 'false';
                    });
                } else {
                    // if ($scope.status.methodname[$state.params.newspapertype] !== 'paper.gdg') {
                    editNewspaperService.getBMRights({}, $state.params.channelid, $stateParams.paperid, $scope.status.methodname[$state.params.newspapertype]).then(function(data) {
                        $scope.status.btnRights = data;
                    });
                    // editcenterRightsService
                    //     .initNewspaperListBtn($scope.status.methodname[$stateParams.newspapertype], $stateParams.paperid)
                    //     .then(function (data) {
                    //         $scope.status.btnRights = data;
                    //     });
                    // }
                    // 获取查看痕迹按钮权限
                    editcenterRightsService.getRightsofBigFace($stateParams.paperid, 'paper.trace').then(function (data) {
                        $scope.status.bigFaceRights = !!data['paper.trace.chakan'] ? 'true' : 'false';
                    });
                }
            }

            /**
             * [getDepartDocAuthority description] 获取部门稿库权限
             *
             * @return  {[type]}  [return description]
             */
            function getDepartDocAuthority() {
                var params = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperkeyOfDeptmentalDoc',
                    DepartmentalDocId: $stateParams.departmentDocId,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    for (var i = 0; i < data.length; i++) {
                        $scope.status.btnRights[data[i]] = true;
                    }
                });
            }

            /**
             * [getUeditorCss description] 加载编辑器中的相关样式
             * @return {[type]} [description]
             */
            function getUeditorCss() {
                $('.lazyload').remove();
                LazyLoad.css('./lib/ueditor2/themes/iframe.css');
            }

            /**
             * [requestData description] 数据请求
             * @param   {[num]}  metadataid  [metadataid description] 稿件ID
             * @return  {[type]}             [return description]
             */
            function requestData(metadataid) {
                $scope.data.params.MetaDataIds = metadataid ? metadataid : $stateParams.bzmetadata;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.data.params, 'post').then(function (data) {
                    data = angular.isArray(data) ? data[0] : data; // 兼容虚拟稿件查询和渠道内查询
                    $scope.item = data;
                    $scope.data.item = data;
                    $scope.data.item.HTMLCONTENT = data.HTMLCONTENT;
                    editingCenterService.queryVerifyDoc($scope.data.item);
                    $scope.status.isShowPicDirective = true;
                    $timeout(function(){
                        new ClipboardJS('#oneKeyClone'); 
                    }, 500);
                    $scope.data.CONTENT = ('<p>' + data.CONTENT + '</p>').replace(/\n/g, '<br/>').replace(/ {2}/g, '　');
                    document.title = data.TITLE;
                    if ($scope.data.preview.atlas == data.DOCTYPEID && data.DOCTYPEID.REMARKS !== undefined) {
                        $scope.data.item.REMARKS = $scope.data.item.REMARKS.replace(/\n/g, '<br/>');
                    }

                    if (!!$stateParams.iwometadataid && !!$scope.list) {
                        $scope.item.ISNOPAYMENT = $scope.list.ISNOPAYMENT;
                        $scope.item.FGD_AUTHINFO = $scope.list.FGD_AUTHINFO;
                        $scope.item.FGD_EDITINFO = $scope.list.FGD_EDITINFO;
                        $scope.data.item.DOCSOURCE = $scope.list.DOCSOURCENAME;
                        $scope.data.item.DOCGENRE = {};
                        $scope.data.item.DOCGENRE.name = $scope.list.DOCGENRE.name;
                    }
                    localstorageItem();
                    loadVersionTimePanel();
                    getDraftStage().then(function() {
                        dealRights();

                        /*
                         * draftCorrelationView[ description] 相关关联稿件
                         */
                        if (!$stateParams.iwometadataid && !$scope.status.onlyPreview) {
                            draftCorrela
                                .initDraftCorrela(
                                    $scope.status.queryMethodName[$state.params.newspapertype],
                                    $stateParams.paperid,
                                    $scope.data.item.METADATAID
                                )
                                .then(function (data) {
                                    $scope.status.RelatedDarft = data;
                                });
                        }
                    });
                    isMark(data.METADATAID);
                });
            }

            // 选择按钮
            $scope.chooseItem = function () {
                var selectCurrentr = angular.copy($scope.data.item.METADATAID);
                $scope.status.selectArrayIdCache = localStorageService.get('newspaperPreviewSelectArray');
                if (
                    $scope.status.selectArrayIdCache === null ||
                    $scope.status.selectArrayIdCache === undefined ||
                    $scope.status.selectArrayIdCache === ''
                ) {
                    localStorageService.set('newspaperPreviewSelectArray', [selectCurrentr]);
                    $scope.status.selectArrayIdCache = [selectCurrentr];
                    isMark(selectCurrentr);
                }
                if ($scope.status.selectArrayIdCache.indexOf(selectCurrentr) > -1) {
                    $scope.status.selectArrayIdCache.splice($scope.status.selectArrayIdCache.indexOf(selectCurrentr), 1);
                    localStorageService.set('newspaperPreviewSelectArray', $scope.status.selectArrayIdCache);
                } else {
                    $scope.status.selectArrayIdCache.push(selectCurrentr);
                    localStorageService.set('newspaperPreviewSelectArray', $scope.status.selectArrayIdCache);
                }
                isMark(selectCurrentr);
            };

            /**
             * [isMark description]是否打标机
             * @param   {[type]}  metadata  [metadata description]
             * @return  {[type]}            [return description]
             */
            function isMark(metadata) {
                if ($scope.status.selectArrayIdCache === '' || $scope.status.selectArrayIdCache === null) {
                    return;
                }
                $timeout(function () {
                    if ($scope.status.selectArrayIdCache.indexOf(metadata) < 0 || $scope.status.selectArrayIdCache.indexOf(metadata) === undefined) {
                        $scope.status.ischoose.mark = false;
                    } else {
                        $scope.status.ischoose.mark = true;
                    }
                });
            }

            /**
             * [localstorageItem description] 缓存每个项
             * @return  {[type]}  [return description]
             */
            function localstorageItem() {
                $scope.status.previewMetadataid = localStorageService.get('newspaperPreviewCache');
                if (($scope.status.selectArrayIdCache = localStorageService.get('newspaperPreviewSelectArray') === null)) {
                    localStorageService.set('newspaperPreviewSelectArray', []);
                    $scope.status.selectArrayIdCache = localStorageService.get('newspaperPreviewSelectArray');
                } else {
                    $scope.status.selectArrayIdCache = localStorageService.get('newspaperPreviewSelectArray');
                }
                isMark($state.params.bzmetadata);
            }

            // 创作轴
            $scope.creationAxis = function () {
                var params = {
                    serviceid: 'mlf_releasesource',
                    methodname: 'addPersonalMaterialOfTxt',
                    PersonalMaterialId: '0',
                    metadataid: $stateParams.bzmetadata,
                    MediaType: '3',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    modalDialog.alertType('添加成功', '', 'success', false);
                });
            };

            // 编辑
            $scope.edit = function () {
                if (!!$stateParams.iwometadataid) {
                    // 融合编辑器
                    var routerParams = {
                        iwometadataid: $stateParams.iwometadataid,
                        iwochnldocid: $stateParams.iwochnldocid,
                        iwoplatform: 0,
                        wzmetadataid: $stateParams.wzmetadataid,
                        wzchnldocid: $stateParams.wzchnldocid,
                        wzchannelid: $stateParams.wzchannelid,
                        wzsiteid: $stateParams.wzsiteid,
                        wzplatform: 0,
                        appmetadataid: $stateParams.appmetadataid,
                        appchnldocid: $stateParams.appchnldocid,
                        appchannelid: $stateParams.appchannelid,
                        appsiteid: $stateParams.appsiteid,
                        appplatform: 0,
                        newspapertype: 2,
                        paperid: $stateParams.paperid,
                        papermetadataid: $stateParams.bzmetadata,
                        wxplatform: 0,
                        wxchannelid: $stateParams.wxchannelid,
                        wxchnldocid: $stateParams.wxchnldocid,
                        wxmetadataid: $stateParams.wxmetadataid,
                        wbmetadataid: $stateParams.wbmetadataid,
                        departdocrelid: $stateParams.departdocrelid,
                        douyinarticleid: $stateParams.douyinarticleid,
                        baijiahaoarticleid: $stateParams.baijiahaoarticleid,
                        qiehaoarticleid: $stateParams.qiehaoarticleid,
                    };
                    if ($stateParams.fromType == 'departmentmanuscript') {
                        routerParams.fromType = 'departmentmanuscript';
                        routerParams.departmentaldocid = $stateParams.departmentDocId;
                    }
                    $state.go($scope.data.fusionRouter[$stateParams.iwotype], routerParams, { reload: true });
                } else {
                    // 非融合编辑器
                    editIsLock.isLock($scope.data.item, 3).then(function (data) {
                        var editPath = $scope.data.newspaperEdit[$scope.data.item.DOCTYPEID];
                        var editParams = {
                            papermetadataid: $stateParams.bzmetadata,
                            paperid: $stateParams.paperid,
                            newspapertype: $state.params.newspapertype,
                        };
                        // if ($scope.status.isawaitrevise) {
                        //     // 是否从待修订页面进入详情页
                        //     editParams.isawaitrevise = $state.params.isawaitrevise;
                        // }
                        var editUrl = $state.href(editPath, editParams);
                        if (data.ISLOCK == 'false') {
                            $window.open(editUrl);
                            $window.close();
                        } else {
                            editIsLock.checkUnlockPermissions($scope.data.item, data).then(function () {
                                $window.open(editUrl);
                            });
                        }
                    });
                }
            };

            /**
             * [openUrl description]打开图片看大图
             * @param  {[type]} url [description]图片地址
             * @return {[type]}     [description]
             */
            $scope.openUrl = function (url) {
                $window.open(url);
            };

            /**
             * [printBtn description] 打印
             * @return  {[type]}  [return description]
             */
            $scope.printBtn = function () {
                // paper
                if (!$stateParams.iwometadataid) {
                    var chnlDocIdsArray = $stateParams.bzmetadata;
                    var params = {
                        serviceid: 'mlf_paper',
                        methodname: 'queryViewDatas',
                        MetaDataIds: chnlDocIdsArray,
                    };
                    $scope.loadingPromise = $q
                        .all([trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get'), requestVersion()])
                        .then(function (data) {
                            var detail = data[0];
                            var version = data[1];
                            detail[0].VERSION = version;
                            trsPrintService.trsPrintDocument(detail); // paper
                        });
                } else {
                    var arr = [];
                    arr.push($scope.data.item);
                    trsPrintService.trsPrintDocument(arr);
                }

                /**
                 * [requestVersion description]查询流程版本
                 *
                 * @return  {[type]}  [return description]
                 */
                function requestVersion() {
                    var versionResult = {};
                    var defer = $q.defer();
                    trsHttpService
                        .httpServer(
                            trsHttpService.getWCMRootUrl(),
                            {
                                serviceid: 'mlf_metadatalog',
                                methodname: 'query',
                                MetaDataId: $stateParams.bzmetadata,
                            },
                            'get'
                        )
                        .then(function (data) {
                            versionResult = data.DATA;
                            defer.resolve(versionResult);
                        });
                    return defer.promise;
                }
            };

            /**
             * [pageTurning description] 翻页 上一篇/下一篇
             * @param {int} direction [description]
             * @return {[type]} [description]
             */
            $scope.pageTurning = function (direction) {
                var ids = $scope.status.previewMetadataid;
                if (typeof $scope.status.previewMetadataid[0] !== 'object') {
                    ids = $scope.status.previewMetadataid = JSON.parse($scope.status.previewMetadataid);
                }
                ids =
                    typeof $scope.status.previewMetadataid[0] === 'object'
                        ? ids.map(function (value, index) {
                            return value.METADATAID;
                        })
                        : $scope.status.previewMetadataid;
                var index = ids.indexOf($scope.data.item.METADATAID);
                var newspaperTypes =
                    typeof $scope.status.previewMetadataid[0] === 'object'
                        ? $scope.status.previewMetadataid.map(function (value, index) {
                            return value.NEWSPAPERTYPE || value.DOCTYPEID;
                        })
                        : [];
                var paperStatusNames =
                    typeof $scope.status.previewMetadataid[0] === 'object'
                        ? $scope.status.previewMetadataid.map(function (value, index) {
                            return value.PAPERSTATUSNAME;
                        })
                        : [];
                var newspapertype;
                var paperStatusName;
                var MetaDataId;
                if (direction > 0) {
                    if (index + 1 === ids.length) {
                        modalDialog.alertType('没有更多稿件了', '', 'warning', false, '');
                        return;
                    }
                    MetaDataId = ids[index + 1];
                    paperStatusName = paperStatusNames[index + 1];
                    newspapertype = typeof $scope.status.previewMetadataid[0] === 'object' ? newspaperTypes[index + 1] : $state.params.newspapertype;
                } else {
                    if (index - 1 < 0) {
                        modalDialog.alertType('您当前处于第一页', '', 'warning', false, '');
                        return;
                    }
                    MetaDataId = ids[index - 1];
                    paperStatusName = paperStatusNames[index - 1];
                    newspapertype = typeof $scope.status.previewMetadataid[0] === 'object' ? newspaperTypes[index - 1] : $state.params.newspapertype;
                }
                $state.go($state.current.name, {
                    bzmetadata: MetaDataId,
                    paperid: $stateParams.paperid,
                    newspapertype: newspapertype,
                    paperstatusname: paperStatusName,
                }, {
                    reload: true
                });
            };

            /**
             * [bigFace description] 查看痕迹
             * @return {[type]} [description]
             */
            $scope.bigFace = function () {
                if ($scope.data.item.DOCTYPEID === '2') {
                    $scope.status.picsModelShow = !$scope.status.picsModelShow;
                }
                $scope.status.previewBigFace.status = !$scope.status.previewBigFace.status;
            };

            /**
             * [goToEdit description]
             *
             * @return  {[type]}  [return description]
             */
            $scope.goToEdit = function () {
                var urlParams = {
                    newspapertype: $state.params.newspapertype,
                    mediaType: '3',
                };
                editingCenterService.routerToEditorWithLock(angular.extend($scope.data.item, urlParams));
            };

            /**
            * [cloneContent description] 复制正文
            *
            * @param   {[type]}  item  [item description]
            *
            * @return  {[type]}        [return description]
            */
            $scope.cloneContent = function () {
                modalDialog.alertType('复制内容成功', '', 'success');      
            };

            /**
             * [loadVersionTimePanel 动态加载流程版本信息]
             *
             * @return  {[type]}  [return description]
             */
            function loadVersionTimePanel() {
                var versionPanel =
                    '<version-time-panel incoming-data="data.item"></version-time-panel>';
                versionPanel = $compile(versionPanel)($scope);
                $element.find('versionPanel').append(versionPanel);
            }
        },
    ]);
